<template>
  <transition-group name="zoom" tag="div" class="position-r full-height-width">
    <div key="croper" v-show="selectedImage !== null && !isMultipleFileAllow" class="position-a full-height-width">
      <cropper
        v-if="selectedImage !== null"
        :img-src="selectedImage"
        :extension="selectedImageExtension"
        ref="cropper">
      </cropper>
    </div>
    <el-row key="selector" v-show="selectedImage === null || isMultipleFileAllow" type="flex" class="position-a full-height-width">
      <el-col v-show="selectedImages.length == 0" class="flex-center">
        <el-upload drag
          class="popup_upload"
          accept="image/*"
          action=""
          :multiple="isMultipleFileAllow"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handlePreview">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text" v-html="resource.imagegalleryuploadertext"></div>
          <div class="el-upload__tip" slot="tip">{{resource.imagegalleryuploadertip}}</div>
        </el-upload>
      </el-col>
      <el-col v-show="selectedImages.length > 0" class="prev-images-container">
        <div class="image-gallery-prev-control"
          v-for="(Image, index) in selectedImages"
          :key="index">
          <span class="el-cross-prev-btn" @click="onImageRemoveClick(index)">
            <i class="el-icon-error el-icon-plus"></i>
          </span>
          <div class="image-gallery-prev-item"
          :style="{ backgroundImage: 'url(' + Image.imagePreview + ')' }">
          </div>
        </div>
      </el-col>
    </el-row>
  </transition-group>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import Cropper from '../Cropper'
import { getExtension } from '@/modules/helper'
import config from '@/config'

export default {
  props: {
    showSave: {
      type: Boolean
    },
    showBack: {
      type: Boolean
    },
    eventBus: {
      type: Object
    },
    isMultipleFileAllow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedImage: null,
      selectedImageExtension: '',
      outputImage: null,
      selectedImages: [],
      count: 0,
      countcheck: true
    }
  },
  computed: {
    ...mapGetters('imageGallery', [ 'visible', 'rendered', 'extraArguments' ]),
    ...mapGetters([
      'resource',
      'subscripton'
    ])
  },
  created () {
    this.eventBus.$on('backClick', this.handleBackClick)
    this.eventBus.$on('saveImage', this.handleSaveImageClick)
  },
  beforeDestroy () {
    this.eventBus.$off('backClick', this.handleBackClick)
    this.eventBus.$off('saveImage', this.handleSaveImageClick)
  },
  methods: {
    handleSaveImageClick () {
      if (this.isMultipleFileAllow) {
        this.eventBus.$emit('images-selected', this.selectedImages)
      } else {
        const result = this.$refs.cropper.getResult()
        this.eventBus.$emit('image-selected', result)
      }
      this.selectedImage = null
      this.selectedImageExtension = ''
    },
    handlePreview (file) {
      console.log(file)
      this.selectedImageExtension = getExtension(file.name)
      let count = 0
      if (this.extraArguments.imagecount) {
        this.count ++
        count = this.count + this.extraArguments.imagecount
      }
      if (this.extraArguments.imagecount && count > 20) {
        if (this.countcheck) {
          this.countcheck = false
          alert('you can not upload more than 20 images in slider')
        }
        return
      } else {
        this.countcheck = true
        var reader = new FileReader()
        let $this = this
        console.log('selectedImageExtension', this.$route.params.SubscriptionModuleId + file.name)
        if (!['jpeg', 'png', 'jpg', 'gif', 'pdf'].includes(this.selectedImageExtension.toLowerCase())) {
          setTimeout(() => {
            $this.$notify.error({
              ...config.notificationDefaultOptions,
              message: this.resource.imagegalleryuploadertip
            })
          }, 100)
          // return
        } else {
          reader.onload = (e) => {
            this.selectedImage = e.target.result
            this.$emit('update:showBack', true)
            this.$emit('update:showSave', true)
            if (this.isMultipleFileAllow) {
              this.count = 0
              this.selectedImages.push({
                ImageName: this.selectedImageExtension === 'pdf' ? this.$route.params.SubscriptionModuleId + '/' + file.name : '',
                Extension: this.selectedImageExtension,
                ImageBase64Data: this.selectedImage.replace(/^data:(image|application)\/(png|jpg|jpeg|pdf);base64,/, ''),
                imagePreview: this.selectedImage
              })
            }
          }
        }
      }
      reader.readAsDataURL(file.raw)
    },
    handleBackClick () {
      this.$emit('update:showBack', false)
      this.$emit('update:showSave', false)
      this.selectedImage = null
      this.selectedImages = []
    },
    onImageRemoveClick (index) {
      this.selectedImages = this.selectedImages.filter((item, rowIndex) => rowIndex !== index)
    }
  },
  components: {
    Cropper
  }
}
</script>
<style scoped>
@keyframes zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
  to {
    opacity: 0;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
  50% {
    opacity: 1;
  }
}

.zoom-enter-active {
  animation: zoomIn 1.5s;
}

.zoom-leave-active {
  animation: zoomOut 1.5s;
}
.image-gallery-prev-control{
  border: 1px solid #ccc;
    border-radius: 5px;
    width: 121px;
    height: 121px;
    margin: 0 10px 7px 0;
    position: relative;
    float: left;
    overflow: hidden;
}
.image-gallery-prev-item {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
.el-cross-prev-btn{
  position: absolute;
    right: -17px;
    top: -7px;
    width: 63px;
    height: 25px;
    background: #13ce66;
    text-align: center;
    transform: rotate(45deg);
    box-shadow: 0 1px 1px #ccc;
}
.el-cross-prev-btn .el-icon-plus{
  position: relative;
  left: 6px;
  top: 3px;
  color: #fff;
  font-weight: bold;
  transform: rotate(45deg);
}
.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}
.prev-images-container {
  /* padding-top: 10px; */
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/ImageGallery/CustomMultipleImageUploader.vue